import { ComparatorReturns } from '@list-store';
import { ColumnDefinitionEnumType, UnitQueueView } from '@mark43/cad-api';
import {
    alphabeticalStringComparator,
    alphanumericStringComparator,
} from '../common/sorting/comparators';
import { ASSIGNED_USER_UNIT } from '../fr-units-list/constants';
import columnDefinitionEnum from '../queues/column-definition.enum';
import { UnitQueueRowData } from '../socket/stream-types';
import { REGULAR_ASCENDING_SORT_DIRECTION, UNIT_EMERGENCY_LABEL } from './constants';

export function isAssignedToEvent(unitQueueView: UnitQueueRowData): boolean {
    return !!unitQueueView.eventQueueView?.id;
}

export function isPrimaryUnit(unitQueueView: UnitQueueRowData): boolean {
    return isAssignedToEvent(unitQueueView) && !unitQueueView.backingUpUnitQueueView;
}

export function isOnlyUnitOnAssignedEvent(unitQueueView: UnitQueueRowData): boolean {
    return (
        isAssignedToEvent(unitQueueView) &&
        !(unitQueueView.hasBackups || unitQueueView.backingUpUnitQueueView)
    );
}

export function formatPrimaryUnit(unitQueueView: UnitQueueRowData): string {
    return isPrimaryUnit(unitQueueView)
        ? `${unitQueueView.callSign} (P)`
        : `${unitQueueView.callSign}`;
}

export function isUnitPrimaryAndNotSolo(unit: UnitQueueView) {
    return (
        unit.id === unit?.eventQueueView?.primaryUnitId &&
        unit?.eventQueueView?.assignedUnits?.length > 1
    );
}

export function filterOutPrimaryUnit(unit: UnitQueueView) {
    return unit?.eventQueueView?.assignedUnits.filter((u) => !u.isPrimary);
}

export function getGroupComparator(
    sortDirection: string,
    columnDefinition?: ColumnDefinitionEnumType
) {
    const comparatorType =
        columnDefinition && columnDefinitionEnum[columnDefinition].sortType === 'alphabetical'
            ? alphabeticalStringComparator
            : alphanumericStringComparator;

    const comparator = (left: string, right: string) => {
        const result = comparatorType(left, right);

        if (left === ASSIGNED_USER_UNIT) return -1;
        if (right === ASSIGNED_USER_UNIT) return 1;

        if (left === UNIT_EMERGENCY_LABEL && right !== UNIT_EMERGENCY_LABEL) {
            return -1;
        } else if (left !== UNIT_EMERGENCY_LABEL && right === UNIT_EMERGENCY_LABEL) {
            return 1;
        }

        return (sortDirection === REGULAR_ASCENDING_SORT_DIRECTION || !sortDirection
            ? result
            : result * -1) as ComparatorReturns;
    };

    return comparator;
}
